'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		receiveExplanationForOrder:
			$resource(
				apiConfig.$get().apiUrl + '/sourcingwaiver/explanation/order/:orderId',
				{
					orderId: '@orderId',
				},
				{
					query: {
						method: 'GET',
						isArray: true
					}
				}
			),
	};

}
